import { errorValidation } from './utils';

let url = $(location).attr('href').split('/').splice(0, 5).join('/');
let segments = url.split('/');
let lang = segments[3];

/**
 * Validate forms
 */
(() => {
	// Order delivery
	$("form[name='order_delivery']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'order_delivery[city]': {
				required: false,
			},
			'order_delivery[address]': {
				required: true,
			},
			'order_delivery[delivery_date]': {
				required: true,
			},
			'order_delivery[type]': {
				required: true,
			},
		},
		messages: {
			'order_delivery[city]': {
				required: window.translations.required,
			},
			'order_delivery[address]': {
				required: window.translations.required,
			},
			'order_delivery[delivery_date]': {
				required: window.translations.required,
			},
			'order_delivery[type]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();

/**
 * Check if all forms are valid
 */
const validateForms = () => {
	let orderDeliveryValid = $("form[name='order_delivery']").valid();

	return orderDeliveryValid;
};

/**
 * Gather data from all forms and send via AJAX
 */
$('#create_order').on('click', function (event) {
	event.preventDefault();

	if (validateForms()) {
		let orderDeliveryData = $("form[name='order_delivery']").serializeArray();
		let orderOptionalData = $("form[name='order_optional']").serializeArray();

		let allData = {};
		$.each(orderDeliveryData, function (index, field) {
			allData[field.name] = field.value;
		});
		$.each(orderOptionalData, function (index, field) {
			allData[field.name] = field.value;
		});

		$('.loader_replace').html(main_loader);

		console.log('allData: ', allData);

		$.ajax({
			url: '/' + lang + '/ajax/order', // путь к обработчику
			type: 'POST', // метод отправки,
			data: allData,
			success: function (response) {
				let result = JSON.parse(response);
				if (result.status == 'success') {
					window.location.href =
						'/' + lang + '/success?order_id=' + result.order_id;
				} else {
					location.reload();
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
});
